<mat-toolbar *ngIf="submitMode || voteMode">
  <div class="submit-banner">
    <span>Words/Phrases starts with: {{ letter }}</span>

    <div class="pull-right">
      <pbg-timer
        [endTime]="expiration"
        [timeLimit]="timeLimit"
        (timerChange)="timerChangeHandler($event)"
      ></pbg-timer>
    </div>
  </div>
</mat-toolbar>

<div class="page-container" [class.has-footer]="submitMode || voteMode || showReady">
  <div *ngIf="showReady || showWaiting || waitMode" class="avatar-container">
    <img class="avatar" src="{{ user.avatar }}" />
    <p><strong>{{ user.name }}</strong></p>

    <div *ngIf="showReady">
      <p>Wait until all users are logged in and then click Ready!</p>
    </div>

    <p *ngIf="waitMode">Hang tight until your friends submit their answers.</p>
    <p *ngIf="showWaiting">Sit tight and relax...</p>
  </div>

  <div *ngIf="submitMode">
    <div *ngFor="let cat of categories">
      <mat-form-field class="example-chip-list">
        <mat-chip-list #chipList>
          <mat-chip *ngFor="let submission of submissions[cat]" [selectable]="false"
            [removable]="true" (removed)="removeSubmission(submission, cat)">
            <span class="submission-label">{{submission}}</span>
            <mat-icon matChipRemove>cancel</mat-icon>
          </mat-chip>
          <input placeholder="{{ cat }}"
            [disabled]="submissions[cat].length >= 3"
                  [matChipInputFor]="chipList"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  [matChipInputAddOnBlur]="true"
                  (matChipInputTokenEnd)="addSubmission($event, cat)">
        </mat-chip-list>
      </mat-form-field>
    </div>
  </div>

  <div *ngIf="voteMode">
    <div class="table-container" *ngFor="let cat of categories">
      <h3>{{ cat }}</h3>
      <table class="mat-table" role="grid">
        <thead>
          <tr class="mat-header-row" role="row">
            <th class="mat-header-cell" role="columnheader">Word or Phrase</th>
            <th class="mat-header-cell" role="columnheader">Vote</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let vote of voteModeSubmissions[cat]" class="mat-row" role="row">
            <td class="mat-cell" role="gridcell">
              {{ vote.word }}
            </td>
            <td class="mat-cell" role="gridcell">
              <mat-slide-toggle
                [(ngModel)]="vote.vote"
              >
              </mat-slide-toggle>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<div class="footer-bar-container" *ngIf="submitMode || voteMode || showReady">
  <div class="footer-bar-content">
    <button *ngIf="submitMode" mat-raised-button color="primary" class="full-width" (click)="submitSubmissions()">Submit</button>
    <button *ngIf="voteMode" mat-raised-button color="primary" class="full-width" (click)="submitVote()">Submit</button>
    <button *ngIf="showReady" mat-raised-button color="primary" class="ready-button full-width" (click)="onReadyHandler()">Ready!</button>
  </div>
</div>
